
import React, { createContext, useState, useContext } from "react";

const energiaAquecimentoContext = createContext();

export default function AmbienteProvider({ children }) {
  const [energiaAquecimento_id, setEnergiaAquecimento_id] = useState();

  return (
    <energiaAquecimentoContext.Provider value={{ energiaAquecimento_id, setEnergiaAquecimento_id }} >
      {children}
    </energiaAquecimentoContext.Provider>
  );
}

export function useEnergiaAquecimentoContext() {
  const context = useContext(energiaAquecimentoContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { energiaAquecimento_id, setEnergiaAquecimento_id } = context;
  return { energiaAquecimento_id, setEnergiaAquecimento_id };
}

